"use client";

import { usePathname } from "next/navigation";
import { Footer } from "./Footer";

export function isProjectsListingPath(pathname: string) {
  return pathname === "/" || pathname.startsWith("/projects");
}

/** Layout footer — hidden on the projects listing so it can live inside the scaler. */
export function LayoutFooter() {
  const pathname = usePathname();
  if (isProjectsListingPath(pathname)) return null;
  return <Footer />;
}

/** Projects listing footer — rendered by ProjectsExperience *outside*
 *  `.projects-scaler` so it stays 1:1 and is not shrunk by the listing zoom. */
export function ListingFooter() {
  return <Footer />;
}
